import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  FormHelperText,
  FormControlLabel,
} from "@material-ui/core";
import PropertyNames from "./PropertyNames";
import { makeStyles } from "@material-ui/core/styles";
import { Trans } from "react-i18next";
import Alert from "@material-ui/lab/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle";
import Switch from "@material-ui/core/Switch";
import { connect } from "react-redux";
import ActionButton from "./components/ActionButton";
import PasswordCheck from "./administration/PasswordCheck";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import defaultLogo from "./images/default-logo.svg";
import SwipeableViews from "react-swipeable-views";
import { taxServiceClient } from "./AxiosClient";
import { useSnackbar } from "notistack";
import { setUser } from "./redux/actions/universalActions";
const useStyles = makeStyles((theme) => ({
  logoCircle: {
    display: "flex",
    width: 100,
    height: 100,
    position: "relative",
    alignItems: "center",
    borderRadius: "50%",
    overflow: "hidden",
    justifyContent: "center",
    backgroundColor: theme.palette.primary.main,
    margin: "0 auto",
    padding: 10,
    border: "2px solid #ccc",
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "column",
  },
  textField: {
    margin: theme.spacing(1),
    width: " calc(100% - 16px)",
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  orSeparator: {
    borderBottom: "1px solid #eee",
    padding: "10px 0",
    position: "relative",
    display: "block",
    marginBottom: 25,
    fontSize: "1em",
  },
  orText: {
    position: "absolute",
    left: "43%",
    top: 0,
    background: "#fff",
    padding: 10,
    color: "rgba(0,0,0,.45)",
  },
}));

function LoginDialog(props) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [oidcSwitch, setOidcSwitch] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirm, setNewPasswordConfirm] = useState("");
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [usernameError, setUsernameError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const classes = useStyles();
  const apiLocation = useSelector((state) => state.setting.apiLocation);
  const redirect = `${window.location.protocol}//${window.location.hostname}${
    window.location.port ? ":" + window.location.port : ""
  }`;

  // let parsed = psl.parse(window.location.hostname);
  const organization = "demo";
  const { enqueueSnackbar } = useSnackbar();

  useEffect(
    () => {
      if (
        !props.isBackdoor &&
        props.open &&
        !props.error &&
        Object.keys(props.loginProps).length > 0
      ) {
        if (!props.loginProps[PropertyNames.AUTH_ALLOW_DATABASE_LOGINS]) {
          const authMethod =
            props.loginProps[PropertyNames.AUTHENTICATION_TYPE];
          if (authMethod === "saml") {
            doSamlLogin();
          } else if (authMethod === "oidc") {
            doOidcLogin();
          }
        }
      }
    },
    [props.loginProps, props.open]
  );
  useEffect(
    () => {
      setUsername("")
      setPassword("")
      props.onClearLoginFields && props.onClearLoginFields();
    },
    [props.clearLoginFields]
  );
  useEffect(
    () => {
      props.onUsernameUpdate && props.onUsernameUpdate(username);
    },
    [username]
  );
  useEffect(
    () => {
      props.onPasswordUpdate && props.onPasswordUpdate(password);
    },
    [password]
  );

  const loginKeypress = (e) => {
    if (e.key === "Enter") {
      doInternalLogin();
    }
  };

  const doInternalLogin = () => {
    if (username === "") {
      setUsernameError(true);
    }
    if (password === "") {
      setPasswordError(true);
    }
    if (username && password) {
      props.onLogin(username, password);
    }
  };

  const doOidcLogin = () => {
    // let base64Email = window.btoa(username);
    window.location.href = `https://${
      props.apiLocation
    }/oauth2/authorize/${organization}?login_hint=${username}&redirect_uri=${redirect}/oauth2/redirect`;
  };

  const doSamlLogin = () => {
    window.location.href = `https://${
      props.apiLocation
    }/authservice/saml/login/alias/${organization}`;
  };

  const doLogin = () => {
    if (props.isBackdoor) {
      doInternalLogin();
      return;
    }

    if (props.loginProps[PropertyNames.AUTHENTICATION_TYPE] === "oidc" && oidcSwitch) {
      doOidcLogin();
    } else if (props.loginProps[PropertyNames.AUTHENTICATION_TYPE] === "saml") {
      doSamlLogin();
    } else {
      doInternalLogin();
    }
  };

  const saveButtonClick = () => {
    let userPromise = taxServiceClient.patch(
      `/user/password/${props.currentUser.userId}`,
      {
        currentPassword: password,
        userId: props.currentUser.userId,
        newPassword: newPassword,
        confirmNewPassword: newPassword,
      }
    );
    userPromise
      .then((userRes) => {
        // setState({ saving: false });
        if (userRes.data.userId === props.currentUser.userId) {
          enqueueSnackbar(props.t("user_admin_user_updated"), {
            variant: "success",
          });
          let newUser = {
            ...props.currentUser,
            requiresPasswordChange: false,
          };
          setUser(newUser);
          props.isReady(newUser);
        }
      })
      .catch((err) => {
        // setState({ saving: false });
        enqueueSnackbar(
          props.t("workflow_error", { error: err.response.data.message }),
          {
            variant: "error",
          }
        );
      });
  };

  const getProvider = () => {
    if (props.loginProps[PropertyNames.AUTHENTICATION_TYPE] === "oidc") {
      let provider = props.loginProps[PropertyNames.OIDC_PROVIDER_CUSTOM_NAME];
      if (props.loginProps[PropertyNames.OIDC_PROVIDER] === "google") {
        return "Google";
      } else if (
        props.loginProps[PropertyNames.OIDC_PROVIDER] === "microsoft"
      ) {
        return "Microsoft";
      } else {
        return provider;
      }
    } else if (props.loginProps[PropertyNames.AUTHENTICATION_TYPE] === "saml") {
      return "SAML";
    }
  };
  return (
    <>
      {!!props.loginProps &&
      (props.isBackdoor ||
        props.loginProps[PropertyNames.AUTHENTICATION_TYPE] === "database" ||
        props.loginProps[PropertyNames.AUTH_ALLOW_DATABASE_LOGINS]) ? (
        <Dialog
          maxWidth="xs"
          fullWidth
          open={props.open}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {!props.currentUser.requiresPasswordChange ? (
              <Trans i18nKey="login_modal_header" />
            ) : (
              <Trans i18nKey="change_your_password" />
            )}
          </DialogTitle>
          <DialogContent>
            {props.error && (
              <Alert severity="error" style={{ marginBottom: 15 }}>
                <AlertTitle><Trans i18nKey="global_error"/></AlertTitle>
                {props.apiError && (
                  <>
                    <Trans i18nKey="api_error_contact_support">
                    </Trans>
                    <br />
                  </>
                )}
                <Trans i18nKey={props.error}>{props.error}</Trans> <br />
                {!props.apiError &&
                  props.loginProps[PropertyNames.AUTHENTICATION_TYPE] &&
                  props.loginProps[PropertyNames.AUTHENTICATION_TYPE] !==
                    "database" &&
                  props.loginProps[PropertyNames.AUTHENTICATION_TYPE] !==
                    "ldap" && (
                    <Trans i18nKey="retry_or_login_internally"/>
                  )}
                {props.error === "error_organization_not_licenced" && (
                  <>
                    <Link to="/licence"><Trans i18nKey="click_add_licence"/></Link>
                  </>
                )}
              </Alert>
            )}
            <div style={{ display: "flex", marginTop: -8, marginBottom: 5 }}>
              <hr
                style={{
                  flex: 1,
                  alignSelf: "center",
                  marginLeft: -24,
                  marginRight: 8,
                }}
              />
              <div className={classes.logoCircle}>
                <img
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "scale-down",
                  }}
                  src={`https://${apiLocation}/taxonomyservice/organization/${organization}/logo`}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = defaultLogo;
                  }}
                  alt="Organization logo"
                />
              </div>
              <hr
                style={{
                  flex: 1,
                  alignSelf: "center",
                  marginRight: -24,
                  marginLeft: 8,
                }}
              />
            </div>
            {props.loginProps[PropertyNames.AUTHENTICATION_TYPE] &&
              props.loginProps[PropertyNames.AUTHENTICATION_TYPE] !==
                "database" &&
              props.loginProps[PropertyNames.AUTHENTICATION_TYPE] !==
                "ldap" && (
                <>
                  <FormControlLabel
                   style={{paddingLeft: "10px"}}
                      control={
                        <Switch
                          checked={oidcSwitch}
                          onChange={(event)=>setOidcSwitch(event.target.checked)}
                        />
                      }
                      label={<Trans
                        i18nKey="login_modal_button_with"
                        values={{ provider: getProvider() }}
                      />}
                  />
                  {/* <Button
                    variant="contained"
                    onClick={doLogin}
                    color="primary"
                    style={{ margin: "8px 0", width: "100%" }}
                    id="external-login-button"
                  >
                    <Trans
                      i18nKey="login_modal_button_with"
                      values={{ provider: getProvider() }}
                    />
                  </Button>
                  <div className={classes.orSeparator}>
                    <span className={classes.orText}>OR</span>
                  </div> */}
                </>
              )} 
            <form className={classes.container}>
              <SwipeableViews
                index={props.currentUser.requiresPasswordChange ? 1 : 0}
                style={{ height: "100%" }}
                slideClassName="swipeable-slide"
                // slideStyle={{ overflowX: "hidden", width: "100%" }}
              >
                <div>
                  {!props.currentUser.requiresPasswordChange && (
                    <>
                      <TextField
                        error={usernameError}
                        className={classes.textField}
                        onChange={(e) => {
                          setUsername(e.target.value);
                          setUsernameError(false);
                        }}
                        variant="outlined"
                        value={username}
                        label="Username"
                        id="username-field"
                        onKeyDown={loginKeypress}
                        aria-describedby="component-error-text"
                      />
                      {usernameError && (
                        <FormHelperText
                          error
                          className={classes.textField}
                          id="component-error-text"
                        >
                          <Trans i18nKey="enter_username" />
                        </FormHelperText>
                      )}
                     {!oidcSwitch && (
                          <TextField
                            error={passwordError}
                            type="password"
                            className={classes.textField}
                            onChange={(e) => {
                              setPassword(e.target.value);
                              setPasswordError(false);
                            }}
                            variant="outlined"
                            value={password}
                            label="Password"
                            id="password-field"
                            onKeyDown={loginKeypress}
                          />
                      )}
                      {passwordError && (
                        <FormHelperText
                          error
                          className={classes.textField}
                          id="component-error-text"
                        >
                          <Trans i18nKey="enter_password" />
                        </FormHelperText>
                      )}
                      <ActionButton
                        variant="contained"
                        onClick={doLogin}
                        color="primary"
                        style={{ margin: "10px 0", width: "100%" }}
                        loading={props.loading}
                        id="login-button"
                      >
                        <Trans i18nKey="login_modal_button" />
                      </ActionButton>
                    </>
                  )}
                </div>
                <div>
                  {props.currentUser.requiresPasswordChange && (
                    <>
                      <PasswordCheck
                        updatePassword={(password) => setNewPassword(password)}
                        saveButtonDisable={(disabled) =>
                          setSaveDisabled(disabled)
                        }
                      />
                      <div style={{ marginTop: 8 }}>
                        <ActionButton
                          variant="contained"
                          onClick={props.forceLogout}
                          color="primary"
                          style={{ margin: "10px 0", width: "100%" }}
                        >
                          <Trans i18nKey="global_logout" />
                        </ActionButton>
                        <ActionButton
                          variant="contained"
                          onClick={saveButtonClick}
                          color="primary"
                          style={{ margin: "10px 0", width: "100%" }}
                          loading={props.loading}
                          disabled={saveDisabled}
                        >
                          <Trans i18nKey="change_password" />
                        </ActionButton>
                      </div>
                    </>
                  )}
                </div>
              </SwipeableViews>
            </form>
            {/* <div className={classes.orSeparator}>
              <span className={classes.orText}>OR</span>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: 20,
              }}
            >
              <Button
                variant="outlined"
                color="default"
                style={{ textTransform: "none", marginBottom: 5 }}
                href={`https://localhost:8090/oauth2/authorize/google?redirect_uri=${redirect}/oauth2/redirect`}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    width: "100%",
                  }}
                >
                  <img
                    src={googleLogo}
                    alt="Google logo"
                    style={{ height: 40, marginRight: 18, marginLeft: 7 }}
                  />
                  <span style={{ marginTop: 7 }}>Sign in with Google</span>
                </div>
              </Button>
            </div> */}
          </DialogContent>
        </Dialog>
      ) : null}
    </>
  );
}
const mapStateToProps = (state) => ({
  applicationProperties: state.setting.applicationProperties,
});
export default connect(
  mapStateToProps,
  null
)(LoginDialog);
